'use client'

import { Image, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const PrivacyManageDataCard = ({
  imageSrc,
  title,
  description,
  link,
  link_a11y,
}: PrivacyCardModel) => {
  const translate = useTranslate()

  return (
    <article className="privacy-center__manage-data-card">
      <div className="privacy-center__manage-data-card-image">
        <Image src={imageSrc} scaling={Image.Scaling.Cover} loading="lazy" />
      </div>
      <div className="privacy-center__manage-data-card-texts">
        <h3 className="privacy-center__manage-data-card-title">{translate(title)}</h3>
        <div className="privacy-center__manage-data-card-description">
          <Text as="p" text={translate(description)} html />
        </div>
        <div className="privacy-center__manage-data-card-link">
          {link && (
            <Text
              as="div"
              text={translate(link)}
              html
              aria={{ 'aria-label': link_a11y ? translate(link_a11y) : '' }}
            />
          )}
        </div>
      </div>
    </article>
  )
}

export default PrivacyManageDataCard
